/* CUBE STORE - comparatore: i titoli delle fasce di gruppo

   Fa due cose sulla tabella di confronto:
     1) traduce i nomi dei gruppi, che l'app scrive in inglese;
     2) nasconde una fascia che ripete il titolo della precedente.

   ---------------------------------------------------------------
   1. I NOMI DEI GRUPPI IN ITALIANO

   L'app divide le righe in gruppi e li chiama con i suoi nomi di
   sistema: Additional details, Variant, Catalog, Pricing, General.
   Fino a ieri non si vedevano - una vecchia regola in base.css li
   copriva scrivendo "SPECIFICHE TECNICHE" al loro posto su ognuno,
   cinque volte nella stessa tabella. Tolta quella (vedi
   assets/cube-compare-righe.css), i nomi veri sono tornati a galla, in
   inglese, in un negozio tutto in italiano.

   Qui vengono tradotti. Il vocabolario copre i cinque gruppi che l'app
   usa oggi; un gruppo che non c'e' in elenco resta com'e' - meglio una
   parola in inglese che una fascia vuota o una traduzione inventata.

   Il confronto e' su testo minuscolo e senza spazi doppi, perche' il
   maiuscolo lo mette il CSS: quello che sta nel DOM e' "Additional
   details".

   ---------------------------------------------------------------
   2. NIENTE TITOLI DOPPI

   Rete di sicurezza per il caso segnalato da Marco: se l'app dovesse
   dare a piu' gruppi lo stesso nome, la fascia che ripete il titolo
   dell'ultima rimasta visibile viene nascosta, e il titolo compare una
   volta sola.

   Perche' "l'ultima rimasta visibile" e non "quella subito prima": con
   tre fasce uguali di fila, confrontando solo con la precedente la
   terza tornerebbe visibile dopo aver nascosto la seconda.

   La tabella viene ricostruita ogni volta che si apre il confronto o si
   toglie un prodotto: da qui l'osservatore, che rifa' il giro a ogni
   modifica invece di guardare una volta sola all'avvio. */
(function () {
  var FASCIA = '.tably-dynamic-modal__group';

  var VOCABOLARIO = {
    'additional details': 'Dettagli',
    'variant': 'Variante',
    'catalog': 'Catalogo',
    'pricing': 'Prezzo',
    'general': 'Generale',
    'inventory': 'Magazzino',
    'shipping': 'Spedizione'
  };

  function pulisci(testo) {
    return (testo || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function traduci(fascia) {
    var voce = VOCABOLARIO[pulisci(fascia.textContent)];
    if (voce && fascia.textContent.trim() !== voce) fascia.textContent = voce;
  }

  function sfoltisci() {
    var fasce = document.querySelectorAll(FASCIA);
    if (!fasce.length) return;

    var ultimo = '';

    for (var i = 0; i < fasce.length; i++) {
      var fascia = fasce[i];
      traduci(fascia);

      var testo = pulisci(fascia.textContent);

      if (testo && testo === ultimo) {
        if (!fascia.hasAttribute('hidden')) {
          fascia.setAttribute('hidden', '');
          fascia.style.display = 'none';
        }
        continue;
      }

      /* non e' un doppione: se era stata nascosta da un giro precedente
         torna visibile */
      if (fascia.hasAttribute('hidden')) {
        fascia.removeAttribute('hidden');
        fascia.style.removeProperty('display');
      }

      if (testo) ultimo = testo;
    }
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      sfoltisci();
    });
  }

  function avvia() {
    sfoltisci();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
